module.exports = __webpack_public_path__ + "img/pokeball.9aaacdb8.png";